<h2 style="margin-top: 0; font-weight: bold;">Erreur lors de la publication :</h2>

<div class="errorMessage" *ngFor="let error of data.messages">
    {{error.content}}
</div>
